import { getMeasuresByGrade } from '../../utils/shared/gradeToMeasureUtils';
import { D8_MEASURES } from '../shared/MeasuresConstants';
import { MEASURE } from './MeasuresConstants';
import { GRADE } from '../shared/GradesConstants';

const { SECOND_GRADE } = GRADE;
const { OVERALL, PSF } = MEASURE;

export const getD8MeasureByGrade = (grade, withOverall, gradeToMeasureMapper) =>
    getMeasuresByGrade(gradeToMeasureMapper, grade).filter(
        measure => D8_MEASURES.includes(measure) && (withOverall || measure !== OVERALL),
    );

export const getFrReadingMeasureGradeMapper = mapper =>
    mapper.map(item => ({
        ...item,
        measures:
            item.key === SECOND_GRADE
                ? item.measures.filter(measure => measure !== PSF)
                : item.measures,
    }));
